import { useState, useEffect, useRef } from "react"

import { XIcon, CircleGauge } from "lucide-react"
import { Input, Separator, DefaultTooltip, Button, DefaultPopover } from "twyne-new.ui"

const RotateDegrees = ({ value = '', index, onChange, type }) => {
  const [open, setOpen] = useState(false)
  const [turns, setTurns] = useState()
  const dialRef = useRef(null)

  const [valueAngle, unit] = value.split('/')

  const angle = Number(valueAngle)
  const circleAngle = Number(angle) - ((turns - 1) * 360)

  useEffect(() => {
    setTurns(undefined)
  }, [open])

  useEffect(() => {
    if (turns === undefined) {
      setTurns(Math.round(angle / 360) + 1)
    }
  }, [turns, angle])

  if (unit && unit !== 'deg' || type !== 'all') {
    return null
  }

  const handleDrag = e => {
    const rect = dialRef.current.getBoundingClientRect()
    const cx = rect.left + rect.width / 2
    const cy = rect.top + rect.height / 2

    const dx = e.clientX - cx
    const dy = e.clientY - cy

    const rad = Math.atan2(dy, dx)
    let deg = (rad * 180) / Math.PI
    deg = (deg + 90 + 360) % 360

    const newValue = String(Math.round(deg) + (turns - 1) * 360)
    onChange(index, newValue, 'value')
  }

  const startDrag = () => {
    window.addEventListener('mousemove', handleDrag)
    window.addEventListener('mouseup', stopDrag)
  }

  const stopDrag = () => {
    window.removeEventListener('mousemove', handleDrag)
    window.removeEventListener('mouseup', stopDrag)
  }

  const handleChangeTurns = value => {
    if (value && Number(value) < 1) {
      return
    }

    setTurns(Number(value))
    onChange(index, String(angle + (value - 1) * 360), 'value')
  }

  return <>
    <DefaultTooltip side='right' content='Configure degrees' triggerProps={{ asChild: true }}>
      <Button variant='light' color='accent' onClick={() => setOpen(true)}>
        <CircleGauge size='14' />
      </Button>
    </DefaultTooltip>

    <DefaultPopover
      wrapperProps={{ open, onOpenChange: setOpen }}
      trigger={<span></span>}
      triggerProps={{ asChild: true }}
      contentProps={{ className: 'w-52', side: 'top', align: 'right' }}
    >
      <div className="w-full">
        <div className='flex justify-between items-center'>
          Rotate degrees
          <XIcon size='16' className='cursor-pointer' onClick={() => setOpen(false)} />
        </div>

        <Separator className='m-0 my-2' />

        <div className='flex flex-col gap-2 items-center justify-center'>
          <div className="flex gap-2 items-center">
            Turns
            <Input
              type='number'
              value={turns}
              onChange={e => handleChangeTurns(e.target.value)}
            />
          </div>

          <div className='flex flex-col items-center space-y-2'>
            <div
              ref={dialRef}
              onMouseDown={startDrag}
              className='relative w-32 h-32 rounded-full cursor-pointer twy-subtle-neutral border-[10px] twy-border-base-accent'
            >
              <div className='absolute w-0.5 h-4 twy-bg-accent left-1/2 top-2' />
              <div className='absolute w-0.5 h-4 twy-bg-accent left-1/2 bottom-2' />
              <div className='absolute w-0.5 h-4 twy-bg-accent left-4 top-1/2 rotate-90 -translate-y-1/2' />
              <div className='absolute w-0.5 h-4 twy-bg-accent right-4 top-1/2 rotate-90 -translate-y-1/2' />
              <div
                onMouseDown={startDrag}
                className='absolute cursor-pointer twy-bg-accent w-4 h-4 rounded-full left-1/2 top-1/2'
                style={{ transform: ` translate(-50%, -50%) rotate(${circleAngle}deg) translateY(-3.7rem) rotate(-${circleAngle}deg)` }}
              />
            </div>

            <p className='twy-text-base-accent'>{angle}°</p>
          </div>

        </div>
      </div>

    </DefaultPopover>
  </>
}

export default RotateDegrees
